import { useAuth } from '../../context/AuthContext'
import {
  getEtiquetasContactoComercial, createEtiquetaContactoComercial, updateEtiquetaContactoComercial, deleteEtiquetaContactoComercial,
} from '../../api/client'
import { puede } from '../../components/comercial/comercialLogica'
import ComercialCatalogo from '../../components/comercial/ComercialCatalogo'

const API = {
  listar: () => getEtiquetasContactoComercial(),
  crear: createEtiquetaContactoComercial,
  actualizar: updateEtiquetaContactoComercial,
  eliminar: deleteEtiquetaContactoComercial,
}

// Comercial > Administración > Etiquetas de contacto. Takes comercial_configurar.
export default function ComercialEtiquetas() {
  const { user } = useAuth()
  return <ComercialCatalogo api={API} textos="etiquetas" puede={puede(user, 'comercial_configurar')} />
}
